import React from 'react'
import { Helmet } from 'react-helmet-async'

const SITE_NAME = 'Huq Up - Cafe & Grill'
const BASE_URL = 'https://www.huqup380.com'
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`

function PageSEO({ title, description, canonical, image, structuredData }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Little Elm, TX | Dine-In, Hookah & Live Sports`
  const ogImage = image || DEFAULT_IMAGE

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Page-specific structured data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  )
}

export default PageSEO
